// src/hooks/useApiRequest.js
import { useDispatch } from "react-redux";
import { apiRequest } from "../../../Redux/apiActions";
export const useApiRequest = () => {
  const dispatch = useDispatch();

  /**
   * @param {Object} options
   * @param {string} options.url - API endpoint (relative or full)
   * @param {string} [options.method="GET"] - HTTP method
   * @param {Object} [options.data] - Request body
   * @param {Object} [options.headers] - Custom headers
   * @param {function} [options.handleSuccess] - Success callback
   * @param {function} [options.handleError] - Error callback
   * @param {string} [options.onSuccessKey] - Redux success key
   * @param {string} [options.onErrorKey] - Redux error key
   */
  const makeApiRequest = ({
    url,
    method = "GET",
    data = null,
    headers = {},
    handleSuccess,
    handleError,
    onSuccessKey,
    onErrorKey,
  }) => {
    // default headers (you can modify or add more globally)
    //logger.log("onErrorKey", onSuccessKey,onErrorKey,)
    const defaultHeaders = {
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid") || "",
    };

    // merge custom headers
    const finalHeaders = { ...defaultHeaders, ...headers };

    // dispatch Redux API request
    dispatch(
      apiRequest({
        url,
        method,
        data,
        headers: finalHeaders,
        onSuccessKey: onSuccessKey,
        onErrorKey: onErrorKey,
        handleSuccess,
        handleError,
      })
    );
  };

  return { makeApiRequest };
};
